<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
    components: { Header, Footer },
    name: "App",
};
</script>

<style>
#app {
    font-family: 'Montserrat' !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue